module.exports = __webpack_public_path__ + "static/img/frozen11.b965145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frozen11.jpg
// module id = z2b4
// module chunks = 0